import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input, DatePicker} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import FormModal from './FormModal'
import UPM from '../../../constants/urlPermissionMappings'
import {PlusOutlined, SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import moment from 'moment'
const storage = window.localStorage

@inject('emailListStore', 'marketingSmsManagementStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: this.props?.location?.state?.addModalVisible || false,
  }
  formRef = React.createRef()

  componentDidMount() {
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const {emailListStore} = this.props
    const {groupList} = emailListStore
    if(groupList.length>0) {
      this.formRef.current.setFieldsValue({
        'marketGroupId': groupList[0]?.id,
      })
    }
  }

  handleSearch = () => {
    const {emailListStore, accountStore, type} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'page': 1,
        'size': PAGE_SIZE_DEFAULT,
        'marketGroupId': type === '2' ? fieldsValue.marketGroupId : null,
        'date': fieldsValue?.date ? moment(fieldsValue?.date).format('YYYY-MM-DD') : null,
        // 'sendStatus': type
      }
      if(type==='1') {
        emailListStore.onSearchJobAction({
          ...params,
          isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        })
      } else {
        emailListStore.onSearchComplateAction(params)
      }
      // emailListStore.onGetConcater({
      //   marketGroupId: fieldsValue.marketGroupId
      // })
    }).catch(err => {
    })
  }
  handleCreate = () => {
    const {marketingSmsManagementStore} = this.props
    marketingSmsManagementStore.onGenerateIDAction().then(response=> {
      if (response?.data?.code === 0) {
        this.setState({
          addModalVisible: true
        })
      }
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  render() {
    const {emailListStore, location, type, t} = this.props
    const {groupList} = emailListStore
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical"
              initialValues={{
                marketGroupId: groupList[0]?.id,
              }}
        >
          <Row gutter={[10, 10]}>
            {
              type === '2' &&
              <Col span={6}>
                <Form.Item name="marketGroupId" label={t(`emailSend.marketingGroup`)}>
                  <Select placeholder={t(`general.pleaseSelect`)} showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                    {groupList?.map(item => (<Select.Option key={item?.id} value={item?.id}>{item?.groupName}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
            }

            {/* <Col span={6}>
              <Form.Item name="date" label={t(`dataFlowLog.operatingTime`)} initialValue={[moment().startOf('day'), moment().endOf('day')]}>
                <RangePicker showTime/>
              </Form.Item>
            </Col> */}
            <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={6} span={6}>
              <Form.Item 
                name="date" 
                label={t(`customerManagement.createTime`)} 
                // initialValue={moment(moment(), 'YYYY-MM-DD')}
              >
                <DatePicker format={'YYYY-MM-DD'} style={{width: '100%'}} allowClear />
              </Form.Item>
            </Col>
            <Col flex='auto' style={{textAlign: 'right', marginTop: 10}}>
              <Button onClick={this.handleSearch} className="ant-btn-red">{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          location={location}
          type={type}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)
